<script setup lang="ts">

import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";
import {Eye} from "@lucide/vue";
import type {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import NotificationTemplate from "@/notification-template/components/NotificationTemplate.vue";

defineProps<{
    template: INotificationTemplate;
}>();
</script>

<template>
  <TooltipProvider :delay-duration="200">
    <Tooltip>
      <TooltipTrigger as-child class="cursor-pointer" @click.stop>
        <Eye class="text-primary size-6" />
      </TooltipTrigger>
      <TooltipContent class="bg-white max-w-sm shadow-2xl" avoid-collisions>
        <NotificationTemplate :template="template" :show-name="false" />
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<style scoped>

</style>
